import localforage from 'localforage';

const checkRows = (card, calledNumbers) => {
  for (let i = 0; i < 5; i++) {
    const row = [
      `B${card.numbers.B[i]}`,
      `I${card.numbers.I[i]}`,
      card.numbers.N[i] === 'FREE' ? 'FREE' : `N${card.numbers.N[i]}`,
      `G${card.numbers.G[i]}`,
      `O${card.numbers.O[i]}`
    ];

    const isRowComplete = row.every(num => 
      num === 'FREE' || calledNumbers.includes(num)
    );

    if (isRowComplete) {
      console.log(`Row ${i + 1} is complete`);
      return true;
    }
  }

  return false;
};

const checkColumns = (card, calledNumbers) => {
  // Check each column (B, I, N, G, O)
  const columns = {
    B: card.numbers.B,
    I: card.numbers.I,
    N: card.numbers.N,
    G: card.numbers.G,
    O: card.numbers.O
  };

  // Check each column separately
  for (const [letter, numbers] of Object.entries(columns)) {
    const isColumnComplete = numbers.every(num => {
      if (num === 'FREE') return true;
      const formattedNumber = `${letter}${num}`;
      return calledNumbers.includes(formattedNumber);
    });

    if (isColumnComplete) {
      console.log(`Column ${letter} is complete`);
      return true;
    }
  }

  return false;
};

const checkDiagonals = (card, calledNumbers) => {
  // Main diagonal (top-left to bottom-right)
  const diagonal1 = [
    `B${card.numbers.B[0]}`,
    `I${card.numbers.I[1]}`,
    card.numbers.N[2] === 'FREE' ? 'FREE' : `N${card.numbers.N[2]}`,
    `G${card.numbers.G[3]}`,
    `O${card.numbers.O[4]}`
  ];

  // Secondary diagonal (bottom-left to top-right)
  const diagonal2 = [
    `B${card.numbers.B[4]}`,
    `I${card.numbers.I[3]}`,
    card.numbers.N[2] === 'FREE' ? 'FREE' : `N${card.numbers.N[2]}`,
    `G${card.numbers.G[1]}`,
    `O${card.numbers.O[0]}`
  ];

  // Check if either diagonal is complete
  const isDiagonal1Complete = diagonal1.every(num => 
    num === 'FREE' || calledNumbers.includes(num)
  );

  const isDiagonal2Complete = diagonal2.every(num => 
    num === 'FREE' || calledNumbers.includes(num)
  );

  if (isDiagonal1Complete) {
    console.log('Main diagonal is complete');
    return true;
  }

  if (isDiagonal2Complete) {
    console.log('Secondary diagonal is complete');
    return true;
  }

  return false;
};

const checkCorners = (card, calledNumbers) => {
  const corners = ['B' + card.numbers.B[0], 'B' + card.numbers.B[4], 'O' + card.numbers.O[0], 'O' + card.numbers.O[4]];
  console.log(corners)
  const isComplete = corners.every(num => calledNumbers.includes(num));
  if (isComplete) {
    console.log('Corners pattern is complete');
    return true;
  }

  return false;
};

const checkSurroundingFree = (card, calledNumbers) => {
  const surroundingFree = [
    `I${card.numbers.I[1]}`, 
    `I${card.numbers.I[3]}`, 
    `G${card.numbers.G[1]}`, 
    `G${card.numbers.G[3]}`
  ];

  const isComplete = surroundingFree.every(num => calledNumbers.includes(num));

  if (isComplete) {
    console.log('Surrounding FREE pattern is complete');
    return true;
  }

  return false;
};

const checkAnyPattern = (card, calledNumbers) => {
  console.log('checkCorners', checkCorners(card, calledNumbers))
  if (checkCorners(card, calledNumbers)) {
    console.log('Winner found: Corners pattern');
    return true;
  }

  // Check surrounding FREE (also fast to check)
  console.log('checkSurroundingFree', checkSurroundingFree(card, calledNumbers))
  if (checkSurroundingFree(card, calledNumbers)) {
    console.log('Winner found: Surrounding FREE pattern');
    return true;
  }

  // Check diagonals
  console.log('checkDiagonals', checkDiagonals(card, calledNumbers))
  if (checkDiagonals(card, calledNumbers)) {
    console.log('Winner found: Diagonal pattern');
    return true;
  }

    // Check columns
  console.log('checkColumns', checkColumns(card, calledNumbers))
  if (checkColumns(card, calledNumbers)) {
    console.log('Winner found: Column pattern');
    return true;
  }

  // Check rows
  console.log('checkRows', checkRows(card, calledNumbers))
  if (checkRows(card, calledNumbers)) {
    console.log('Winner found: Row pattern');
    return true;
  }

  return false;
};

const checkFullCard = (card, calledNumbers) => {
// Check each column (B, I, N, G, O)
const columns = ['B', 'I', 'N', 'G', 'O'];

for (let col of columns) {
  for (let i = 0; i < 5; i++) {
    const num = card.numbers[col][i];
    
    // Skip if it's the FREE space
    if (num === 'FREE') continue;
    
    // Check if the formatted number has been called
    const formattedNumber = `${col}${num}`;
    if (!calledNumbers.includes(formattedNumber)) {
      return false; // Return false as soon as we find an uncalled number
    }
  }
}

console.log('Full card pattern is complete');
return true;
};

const checkLShape = (card, calledNumbers) => {
// Check left vertical line (B column)
const leftVertical = [
  `B${card.numbers.B[0]}`, // top
  `B${card.numbers.B[1]}`, // second
  `B${card.numbers.B[2]}`, // middle
  `B${card.numbers.B[3]}`, // fourth
  `B${card.numbers.B[4]}`  // bottom
];

// Check bottom horizontal line (excluding B since it's checked in vertical)
const bottomRow = [
  `I${card.numbers.I[4]}`,
  `N${card.numbers.N[4]}`,
  `G${card.numbers.G[4]}`,
  `O${card.numbers.O[4]}`
];

const isHorizontalComplete = bottomRow.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (!isHorizontalComplete) return false;

const isVerticalComplete = leftVertical.every(num => 
  calledNumbers.includes(num)
);

if (!isVerticalComplete) return false;


if (isVerticalComplete && isHorizontalComplete) {
  console.log('L shape pattern is complete');
  return true;
}

return false;
};

const checkBothDiagonals = (card, calledNumbers) => {
// Main diagonal (top-left to bottom-right)
const diagonal1 = [
  `B${card.numbers.B[0]}`,
  `I${card.numbers.I[1]}`,
  card.numbers.N[2] === 'FREE' ? 'FREE' : `N${card.numbers.N[2]}`,
  `G${card.numbers.G[3]}`,
  `O${card.numbers.O[4]}`
];

// Secondary diagonal (bottom-left to top-right)
const diagonal2 = [
  `B${card.numbers.B[4]}`,
  `I${card.numbers.I[3]}`,
  card.numbers.N[2] === 'FREE' ? 'FREE' : `N${card.numbers.N[2]}`,
  `G${card.numbers.G[1]}`,
  `O${card.numbers.O[0]}`
];

// Check main diagonal
const isDiagonal1Complete = diagonal1.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (!isDiagonal1Complete) return false;

// Check secondary diagonal
const isDiagonal2Complete = diagonal2.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (isDiagonal1Complete && isDiagonal2Complete) {
  console.log('Both diagonals pattern is complete');
  return true;
}

return false;
};

const checkTShape = (card, calledNumbers) => {
const topRow = [
  `B${card.numbers.B[0]}`,
  `I${card.numbers.I[0]}`,
  `N${card.numbers.N[0]}`,
  `G${card.numbers.G[0]}`,
  `O${card.numbers.O[0]}`
];

const middleVertical = [
  `N${card.numbers.N[1]}`,
  card.numbers.N[2] === 'FREE' ? 'FREE' : `N${card.numbers.N[2]}`,
  `N${card.numbers.N[3]}`,
  `N${card.numbers.N[4]}`
];

const isTopComplete = topRow.every(num => 
  calledNumbers.includes(num)
);

if (!isTopComplete) return false;

const isMiddleVerticalComplete = middleVertical.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (isTopComplete && isMiddleVerticalComplete) {
  console.log('T shape pattern is complete');
  return true;
}

return false;
};

const checkSevenShape = (card, calledNumbers) => {
// Top horizontal line
const topRow = [
  `B${card.numbers.B[0]}`,
  `I${card.numbers.I[0]}`,
  `N${card.numbers.N[0]}`,
  `G${card.numbers.G[0]}`,
  `O${card.numbers.O[0]}`
];

// Secondary diagonal (excluding top O since it's checked in topRow)
const secondaryDiagonal = [
  `O${card.numbers.O[0]}`, // already checked in topRow
  `G${card.numbers.G[1]}`,
  card.numbers.N[2] === 'FREE' ? 'FREE' : `N${card.numbers.N[2]}`,
  `I${card.numbers.I[3]}`,
  `B${card.numbers.B[4]}`
];

// First check top horizontal line
const isTopComplete = topRow.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (!isTopComplete) return false;

// Then check secondary diagonal
const isDiagonalComplete = secondaryDiagonal.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (isTopComplete && isDiagonalComplete) {
  console.log('Seven shape pattern is complete');
  return true;
}

return false;
};

const checkInnerSquare = (card, calledNumbers) => {
// Inner square positions (3x3 excluding outer rows and columns)
const innerSquare = [
  // Top row of inner square (row 1)
  `I${card.numbers.I[1]}`,
  `N${card.numbers.N[1]}`,
  `G${card.numbers.G[1]}`,

  // Middle row of inner square (row 2)
  `I${card.numbers.I[2]}`,
  card.numbers.N[2] === 'FREE' ? 'FREE' : `N${card.numbers.N[2]}`,
  `G${card.numbers.G[2]}`,

  // Bottom row of inner square (row 3)
  `I${card.numbers.I[3]}`,
  `N${card.numbers.N[3]}`,
  `G${card.numbers.G[3]}`
];

// Check if all inner square numbers have been called
const isInnerSquareComplete = innerSquare.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (isInnerSquareComplete) {
  console.log('Inner square pattern is complete');
  return true;
}

return false;
};

const checkDiamond = (card, calledNumbers) => {
// Diamond pattern positions (following the correct path)
const diamond = [
  // Start at top N
  `N${card.numbers.N[0]}`,
  
  // Down to left side
  `I${card.numbers.I[1]}`,
  `B${card.numbers.B[2]}`,
  `I${card.numbers.I[3]}`,
  
  // Bottom N
  `N${card.numbers.N[4]}`,
  
  // Up right side
  `G${card.numbers.G[3]}`,
  `O${card.numbers.O[2]}`,
  `G${card.numbers.G[1]}`
];

// Check if all diamond positions have been called
const isDiamondComplete = diamond.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (isDiamondComplete) {
  console.log('Diamond pattern is complete');
  return true;
}

return false;
};

// C Pattern Check
const checkCPattern = (card, calledNumbers) => {
// C pattern positions
const cPattern = [
  // Top row
  `B${card.numbers.B[0]}`,
  `I${card.numbers.I[0]}`,
  `N${card.numbers.N[0]}`,
  `G${card.numbers.G[0]}`,
  `O${card.numbers.O[0]}`,
  
  // Left vertical (excluding top B since it's already included)
  `B${card.numbers.B[1]}`,
  `B${card.numbers.B[2]}`,
  `B${card.numbers.B[3]}`,
  `B${card.numbers.B[4]}`,
  
  // Bottom row (excluding B since it's included in vertical)
  `I${card.numbers.I[4]}`,
  `N${card.numbers.N[4]}`,
  `G${card.numbers.G[4]}`,
  `O${card.numbers.O[4]}`
];

// Check if all C pattern positions have been called
const isCPatternComplete = cPattern.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (isCPatternComplete) {
  console.log('C pattern is complete');
  return true;
}

return false;
};

const checkNumberFour = (card, calledNumbers) => {
// Vertical line (N column)
const vertical = card.numbers.N.map(num => 
  num === 'FREE' ? 'FREE' : `N${num}`
);

// Horizontal line (middle positions)
const horizontal = [
  `I${card.numbers.I[1]}`,
  `I${card.numbers.I[2]}`,
  `B${card.numbers.B[2]}`,
  `G${card.numbers.G[2]}`,
  `O${card.numbers.O[2]}`
];

// Check vertical line (N column)
const isVerticalComplete = vertical.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (!isVerticalComplete) return false;

// Check horizontal line
const isHorizontalComplete = horizontal.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (isVerticalComplete && isHorizontalComplete) {
  console.log('Number four pattern is complete');
  return true;
}

return false;
};

const checkHShape = (card, calledNumbers) => {
// Left vertical line (B column)
const leftVertical = [
  `B${card.numbers.B[0]}`,
  `B${card.numbers.B[1]}`,
  `B${card.numbers.B[2]}`,
  `B${card.numbers.B[3]}`,
  `B${card.numbers.B[4]}`
];

// Right vertical line (O column)
const rightVertical = [
  `O${card.numbers.O[0]}`,
  `O${card.numbers.O[1]}`,
  `O${card.numbers.O[2]}`,
  `O${card.numbers.O[3]}`,
  `O${card.numbers.O[4]}`
];

// Middle horizontal line (excluding B and O since they're in verticals)
const middleHorizontal = [
  `I${card.numbers.I[2]}`,
  card.numbers.N[2] === 'FREE' ? 'FREE' : `N${card.numbers.N[2]}`,
  `G${card.numbers.G[2]}`
];

// First check left vertical line
const isLeftVerticalComplete = leftVertical.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (!isLeftVerticalComplete) return false;

// Then check right vertical line
const isRightVerticalComplete = rightVertical.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (!isRightVerticalComplete) return false;

// Finally check middle horizontal line
const isMiddleHorizontalComplete = middleHorizontal.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (isLeftVerticalComplete && isRightVerticalComplete && isMiddleHorizontalComplete) {
  console.log('H shape pattern is complete');
  return true;
}

return false;
};

const checkCross = (card, calledNumbers) => {
// Middle row (horizontal line)
const horizontal = [
  `B${card.numbers.B[2]}`,
  `I${card.numbers.I[2]}`,
  card.numbers.N[2] === 'FREE' ? 'FREE' : `N${card.numbers.N[2]}`,
  `G${card.numbers.G[2]}`,
  `O${card.numbers.O[2]}`
];

// Middle column (vertical line, excluding N2 as it's in horizontal)
const vertical = [
  `N${card.numbers.N[0]}`,
  `N${card.numbers.N[1]}`,
  `N${card.numbers.N[3]}`,
  `N${card.numbers.N[4]}`
];

// First check horizontal line
const isHorizontalComplete = horizontal.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (!isHorizontalComplete) return false;

// Then check vertical line
const isVerticalComplete = vertical.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (isHorizontalComplete && isVerticalComplete) {
  console.log('Cross pattern is complete');
  return true;
}

return false;
};

// Outer Circle Check
const checkOuterSquare = (card, calledNumbers) => {
// Top row
const topRow = [
  `B${card.numbers.B[0]}`,
  `I${card.numbers.I[0]}`,
  `N${card.numbers.N[0]}`,
  `G${card.numbers.G[0]}`,
  `O${card.numbers.O[0]}`
];

// Bottom row
const bottomRow = [
  `B${card.numbers.B[4]}`,
  `I${card.numbers.I[4]}`,
  `N${card.numbers.N[4]}`,
  `G${card.numbers.G[4]}`,
  `O${card.numbers.O[4]}`
];

// Left side (excluding corners as they're in top/bottom rows)
const leftSide = [
  `B${card.numbers.B[1]}`,
  `B${card.numbers.B[2]}`,
  `B${card.numbers.B[3]}`
];

// Right side (excluding corners as they're in top/bottom rows)
const rightSide = [
  `O${card.numbers.O[1]}`,
  `O${card.numbers.O[2]}`,
  `O${card.numbers.O[3]}`
];

// Check all sides
const isComplete = [...topRow, ...bottomRow, ...leftSide, ...rightSide]
  .every(num => num === 'FREE' || calledNumbers.includes(num));

if (isComplete) {
  console.log('Outer square pattern is complete');
  return true;
}

return false;
};

const checkZPattern = (card, calledNumbers) => {
// Top row
const topRow = [
  `B${card.numbers.B[0]}`,
  `I${card.numbers.I[0]}`,
  `N${card.numbers.N[0]}`,
  `G${card.numbers.G[0]}`,
  `O${card.numbers.O[0]}`
];

// Diagonal (top-right to bottom-left)
const diagonal = [
  `O${card.numbers.O[1]}`,
  `G${card.numbers.G[2]}`,
  card.numbers.N[2] === 'FREE' ? 'FREE' : `N${card.numbers.N[2]}`,
  `I${card.numbers.I[3]}`
];

// Bottom row
const bottomRow = [
  `B${card.numbers.B[4]}`,
  `I${card.numbers.I[4]}`,
  `N${card.numbers.N[4]}`,
  `G${card.numbers.G[4]}`,
  `O${card.numbers.O[4]}`
];

// First check top row
const isTopComplete = topRow.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (!isTopComplete) return false;

// Then check diagonal
const isDiagonalComplete = diagonal.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (!isDiagonalComplete) return false;

// Finally check bottom row
const isBottomComplete = bottomRow.every(num => 
  num === 'FREE' || calledNumbers.includes(num)
);

if (isTopComplete && isDiagonalComplete && isBottomComplete) {
  console.log('Z pattern is complete');
  return true;
}

return false;
};

export const verifyWin = async (paletteNumber, calledNumbers, winningPattern) => {
  try {
    if (!paletteNumber) {
      throw new Error('Palette number not found');
    }

    const cards = await localforage.getItem('bingoCards');
    paletteNumber = parseInt(paletteNumber, 10);
    
    // Find the specific card using the palette number
    const card = cards.find(c => c.paletteNumber === paletteNumber);
    if (!card) {
      throw new Error('Card not found in localforage'); 
    }

    if (winningPattern[0] === 'any') {
      return checkAnyPattern(card, calledNumbers);
    }

    switch(winningPattern) {
      case 'rows':
        return checkRows(card, calledNumbers);
      case 'columns':
        return checkColumns(card, calledNumbers);
      case 'diagonals':
        return checkDiagonals(card, calledNumbers);
      case 'corners':
        return checkCorners(card, calledNumbers);
      case 'surroundingFree':
        return checkSurroundingFree(card, calledNumbers);
      case 'fullCard':
        return checkFullCard(card, calledNumbers);
      case 'lShape':
        return checkLShape(card, calledNumbers);
      case 'bothDiagonals':
        return checkBothDiagonals(card, calledNumbers);
      case 'tShape':
        return checkTShape(card, calledNumbers);
      case 'sevenShape':
        return checkSevenShape(card, calledNumbers);
      case 'innerSquare':
        return checkInnerSquare(card, calledNumbers);
      case 'diamond':
        return checkDiamond(card, calledNumbers);
      case 'cPattern':
        return checkCPattern(card, calledNumbers);
      case 'numberFour':
        return checkNumberFour(card, calledNumbers);
      case 'hShape':
        return checkHShape(card, calledNumbers);
      case 'cross':
        return checkCross(card, calledNumbers);
      case 'outerSquare':
        return checkOuterSquare(card, calledNumbers);
      case 'zPattern':
        return checkZPattern(card, calledNumbers);
      default:
        return false;
    }
  } catch (error) {
    console.error('Error verifying win:', error);
    return false;
  }
};